import Navbar from "../../components/Navbar";
import Spineintel from "../../assets/img/spineintel2.png";
import { FaInstagram, FaLinkedin } from "react-icons/fa";

const About = () => {
  return (
    <div>
      <Navbar />

      <section id="contact" className="h-full md:h-screen md:grid grid-cols-4">
        <div className="col-span-1 flex items-center mx-auto my-8 md:my-0">
          <img src={Spineintel} alt="Tap tap contact" />
        </div>

        <div className="col-span-3 bg-black text-white flex">
          <div className="p-8 md:mx-20 mt-32">
            <h1 className="mt-20 text-5xl font-bold leading-tight">About Us</h1>
            <div className="w-3/4">
            <p className="my-3 mt-6">
              At SpineIntel, we are inspired to build simple solutions to
              complex challenges. TapTap is a reflection of that thought
              process. </p>
              <p className="mt-3">
              We created TapTap to simplify the payment experience for
              millions of Nigerians, starting with easy, accessible bill
              payments. </p>
              <p className="mt-3">
              We believe technology should feel effortless. That’s the
              standard we build for.
            </p>
            </div>
            <div className="mt-5 flex gap-3">
                <a href="https://www.instagram.com/spineintel?igsh=dHRub3RmMDJuNnpn&utm_source=qr">
                <FaInstagram size={30}/>
                </a>
                <a href="https://www.linkedin.com/company/spineintel-labs/">
               <FaLinkedin size={30}/>
                </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
